var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ModalMessage',{attrs:{"name":"windExclusionSignModal","title":"Wind Exclusion Acknowledgement","description":"You MUST have the Wind Exclusion form signed before binding. Please remember to submit the form to your underwriter.","buttons":[
      {
        text: `Continue`,
        classList: ['bg-white text-atlas-blue border-atlas-blue'],
        click: _vm.handleCloseWindExclusionSignModal
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }